import { useMutation } from "@tanstack/react-query";

import {
  RequestCesSurveyType,
  SubmitCesSurveyResponseType,
} from "@/domain/cesSurveys";

import { CesSurveysApi } from "../api/cesSurveysApi";

export const useRequestCesSurveyMutation = () => {
  return useMutation({
    mutationFn: async (params: RequestCesSurveyType) =>
      CesSurveysApi.requestCesSurvey(params),
  });
};

export const useSubmitCesSurveyResponseMutation = () => {
  return useMutation({
    mutationFn: async ({
      id,
      cesSurveyData,
    }: {
      id: string;
      cesSurveyData: SubmitCesSurveyResponseType;
    }) => CesSurveysApi.submitCesSurveyResponse(id, cesSurveyData),
    // The prompt thanks the patient without waiting for the response, so retry
    // a flaky connection rather than silently losing the answer
    retry: 2,
  });
};
